(() => {
  if (customElements.get('stock-shipping-notice')) return;

  // Charge le fichier officiel Shopify /services/javascripts/currencies.js a la demande
  // (uniquement si la devise du visiteur differe de celle de la boutique) pour convertir
  // le seuil de livraison gratuite. Meme approche que le snippet progress-bar.
  let currencyPromise = null;
  function loadCurrencies() {
    if (window.Currency && typeof window.Currency.convert === 'function') {
      return Promise.resolve();
    }
    if (currencyPromise) return currencyPromise;
    currencyPromise = new Promise((resolve) => {
      const s = document.createElement('script');
      s.src = '/services/javascripts/currencies.js';
      s.onload = () => resolve();
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });
    return currencyPromise;
  }

  class StockShippingNotice extends HTMLElement {
    connectedCallback() {
      // La conversion du seuil est independante de la config produit : elle doit
      // aussi tourner hors page produit (ex: barre d'annonce defilante, ou il n'y
      // a pas d'element de config). On l'execute donc avant le retour anticipe.
      this._convertThreshold();

      const configEl = this.querySelector('[data-stock-shipping-config]');
      if (!configEl) return;

      try {
        this.config = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      this.variantStates = {};
      (this.config.variants || []).forEach((v) => {
        this.variantStates[v.id] = v;
      });

      this.statusEl = this.querySelector('[data-stock-status]');
      this.labelEl = this.querySelector('[data-stock-label]');
      this.delayEl = this.querySelector('[data-stock-delay]');
      this.sepEl = this.querySelector('[data-stock-sep]');

      this._onVariantChange = this._onVariantChange.bind(this);
      document.addEventListener('variant:change', this._onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    _onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      const entry = this.variantStates[variant.id];
      // Variante absente du mapping (ex: quick-buy d'un autre produit) -> on ignore
      if (!entry) return;

      this._renderState(entry.state, entry.count);
    }

    _renderState(state, count) {
      if (!this.statusEl) return;

      const states = this.config.states || {};

      if (state === 'sold_out' || !states[state]) {
        this.statusEl.hidden = true;
        return;
      }

      this.statusEl.hidden = false;
      this.statusEl.setAttribute('data-state', state);

      const data = states[state];
      let label = data.label || '';
      // En decompte, le serveur n'envoie le nombre exact que sous le seuil (sinon 0)
      if (state === 'low_count') {
        label = label.replace('{count}', count == null ? '' : count);
      }
      // Libelles en inline_richtext (peuvent contenir <strong>/<em>) -> innerHTML.
      // Contenu issu des reglages du theme (marchand), pas d'entree visiteur.
      if (this.labelEl) this.labelEl.innerHTML = label;
      if (this.delayEl) this.delayEl.innerHTML = data.delay || '';
      if (this.sepEl) this.sepEl.hidden = !(label && data.delay);
    }

    _convertThreshold() {
      const amountEl = this.querySelector('[data-free-shipping-amount]');
      if (!amountEl) return;

      const thresholdCents = parseInt(this.dataset.thresholdCents, 10);
      const shopCurrency = this.dataset.shopCurrency;
      const customerCurrency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || shopCurrency;

      if (!thresholdCents || !shopCurrency || customerCurrency === shopCurrency) return;

      const locale = (window.Shopify && window.Shopify.locale) || 'fr';

      loadCurrencies().then(() => {
        if (!window.Currency || typeof window.Currency.convert !== 'function') return;

        const converted = window.Currency.convert(thresholdCents / 100, shopCurrency, customerCurrency);
        if (typeof converted !== 'number' || isNaN(converted)) return;

        try {
          amountEl.textContent = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: customerCurrency,
            maximumFractionDigits: 0,
          }).format(converted);
        } catch (e) {
          // Devise non reconnue par Intl : on garde le montant rendu cote serveur
        }
      });
    }
  }

  customElements.define('stock-shipping-notice', StockShippingNotice);
})();
